import { render, staticRenderFns } from "./EditSpeak.vue?vue&type=template&id=56767b44&scoped=true&"
import script from "./EditSpeak.vue?vue&type=script&lang=ts&"
export * from "./EditSpeak.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56767b44",
  null
  
)

export default component.exports